export const VTO_FOUNDATION_QR_CODE_OVERLAY_DISCLAIMER =
    'vto-foundation-qr-code-overlay-disclaimer';
export const VTO_FOUNDATION_QR_CODE_OVERLAY_DETAIL = 'vto-foundation-qr-code-overlay-detail';
export const VTO_FOUNDATION_QR_CODE_OVERLAY_SUBTITLE = 'vto-foundation-qr-code-overlay-subtitle';
export const VTO_FOUNDATION_QR_CODE_OVERLAY_TITLE = 'vto-foundation-qr-code-overlay-title';

export const VTO_OPEN_QUERY_PARAM = 'vto_open';
export const VTO_OPEN_QUERY_VALUE = '1';
